<template>
  <Row type="flex" justify="space-around" align="middle" class="email-signup-section border-top" style="">
    <Col class="item">
      <!-- Stay in Touch! -->
      <h2 class="title">Keep in Touch!</h2>
      <!-- Join our email list to recieve product updates and tips for managing and reporting on your portfolio</p> -->
      <!-- Sign up to recieve product updates and tips for managing your portfolio -->
      <!-- Sign up to recieve product updates and tips for managing your portfolio. -->
       <!-- product and company update emails.</p> -->
       <p class="subtitle">Join our email list to receive product updates, company news, and tips on how to manage and analyze your portfolio.</p>
    </Col>
    <Col>
      <EmailListSignupForm size="large"></EmailListSignupForm>
    </Col>
  </Row>
</template>
<script>
import GetStartedButton from './GetStartedButton';
import EmailListSignupForm from './EmailListSignupForm';

export default {
  components: { GetStartedButton, EmailListSignupForm },
};
</script>
<style lang="css" scoped>
.email-signup-section {
  padding: 68px 5vw;
  /*background: #e7eef1;*/
  /*background: #e8eef2*/
  background: #ecf2f4;
}

.title {
  font-size: 28px;
}

.subtitle {
  font-size: 1rem;
  max-width: 400px;
  padding-bottom: 8px;
}

.item {
  padding-top: 28px;
  padding-bottom: 28px;
}

.form-input {
  width: 340px;
}
</style>


// WEBPACK FOOTER //
// src/components/EmailSignupSection.vue